export const Bio = {
  name: "Mohamed Bahir Hussain",
  roles: [
    "a Data Analyst",
    "a Application Programmer",
    "a Full Stack Developer",
    "a JAVA Developer",
    "a API Systems Developer",
    "Developing AI Development",
    "Doing R & D",
    "a Content Writer",
  ],
  image: "mohamedbahirhussain.jpeg",
  description:
    "I'm passionate about distributed systems, fintech, healthcare, e-commerce, and more, with a keen interest in integrating AI to drive innovation. I'm deeply engaged with emerging technologies like AI, machine learning, and big data analytics. Continuously exploring and expanding my knowledge in these areas excites me. Let's connect and collaborate on tech discussions or projects!",
  github: "https://github.com/mohamedbahirhussain",
  resume:
    "https://drive.google.com/uc?export=download&id=15dwEPfMrMMjBlkqG_aex6-_g7VY9FALm",
  experiences:
    "https://drive.google.com/uc?export=download&id=1ojQVT1WfSFTmYOQQi-4VaDylM_JXE1YN",
  sce:
    "https://drive.google.com/uc?export=download&id=1546z4uaAf7gw8ZE0QeBAWtE-YYO-67Ik",
  linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
  twitter: "https://x.com/bahirhussain1",
  insta: "https://www.instagram.com/bahir_hussain_thaj/",
  facebook: "https://web.facebook.com/mohamedbahir.hussainthaj.9",
};

export const skills = [
  {
  "title": "Data Analyst",
  "skills": [
    {
      "name": "Python",
      "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg"
    },
    {
      "name": "Pandas",
      "image": "https://upload.wikimedia.org/wikipedia/commons/e/ed/Pandas_logo.svg"
    },
    {
      "name": "NumPy",
      "image": "https://upload.wikimedia.org/wikipedia/commons/3/31/NumPy_logo_2020.svg"
    },
    {
      "name": "Power BI",
      "image": "https://upload.wikimedia.org/wikipedia/commons/c/cf/New_Power_BI_Logo.svg"
    },
    {
      "name": "Tableau",
      "image": "https://cdn.worldvectorlogo.com/logos/tableau-software.svg"
    },
    {
      "name": "Excel (Advanced)",
      "image": "https://upload.wikimedia.org/wikipedia/commons/7/73/Microsoft_Excel_2013-2019_logo.svg"
    },
    {
      "name": "MySQL",
      "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg"
    },
    {
      "name": "PostgreSQL",
      "image": "https://www.postgresql.org/media/img/about/press/elephant.png"
    },
    {
      "name": "MongoDB",
      "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg"
    },
    {
      "name": "ETL Pipelines",
      "image": "https://cdn-icons-png.flaticon.com/512/3039/3039386.png"
    },
    {
      "name": "AWS (S3, RDS, Lambda)",
      "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original-wordmark.svg"
    },
    {
      "name": "Google BigQuery",
      "image": "https://www.vectorlogo.zone/logos/google_bigquery/google_bigquery-icon.svg"
    },
    {
      "name": "Data Visualization",
      "image": "https://cdn-icons-png.flaticon.com/512/1829/1829864.png"
    }
  ]
},
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "Vue Js",
        image: "/vuejs.png",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Tailwind CSS",
        image: "/tailwindcss.png",
      },
      {
        name: "React Native",
        image: "/react-native.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image: "https://cdn.worldvectorlogo.com/logos/java.svg",
      },
      {
        name: "Spring Boot",
        image:
          "https://miro.medium.com/v2/resize:fit:585/1*69OXNxfqIfRNhnBRqTH0Gg.png",
      },
      {
        name: "HIBERNATE",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLJZuEp7cA5anZQj0aPYwh5ldRpP4j_OF9iQbw5ZUJMPagFtSEihwGWab8rJuJlrGX9_s&usqp=CAU",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "PHP",
        image: "/php.png",
      },
    ],
  },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },
  {
    title: "Others",
    skills: [
      {
        name: "Wso2",
        image: "/wso2.png",
      },
      {
        name: "Power BI",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/New_Power_BI_Logo.svg/1200px-New_Power_BI_Logo.svg.png",
      },
      {
        name: "Microservice",
        image: "https://cdn-icons-png.freepik.com/512/9390/9390695.png",
      },
      {
        name: "Kubernets",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPKA-U9m5BxYQDF1O7atMfj9EMMXEoGu4t0Q&s",
      },
      {
        name: "Git",
        image: "/git.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image: "/postman.svg",
      },
      {
        name: "Wordpress",
        image: "/wordpress-1.png",
      },
      // {
      //   name: "Adobe XD",
      //   image:
      //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      // },
      {
        name: "Figma",
        image: "/figma.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 1,
    img: "/colombomail.png",
    role: "Software Engineer & Data Analyst",
    company: "Super Save Lanka (PVT) Ltd",
    emptype: "Dubai, United Arab Emirates · Full-time",
    duration: "September 2022 – January 2025",
    desc: [
      "As a Software Engineer & Data Analyst at Super Save Lanka, I led the design and optimization of data-driven systems, combining software engineering with advanced business intelligence practices. I was responsible for developing real-time data pipelines, building predictive analytics models, and delivering actionable insights that supported executive decision-making and operational efficiency across logistics, e-commerce, and financial platforms."
    ],
    keyProjects: [
      {
        name: "Real-Time Multi-Currency FinTech Platform",
        details: [
          "Developed and maintained a multi-currency FinTech platform with dynamic currency conversion and real-time transaction monitoring.",
          "Integrated secure payment systems with banking APIs, reducing settlement time by 25% and enhancing reconciliation accuracy.",
          "Implemented digital wallet functionality with automated fraud detection using transaction pattern analysis."
        ]
      },
      {
        name: "Business Intelligence & Data Analytics",
        details: [
          "Designed and deployed end-to-end ETL pipelines using Python and SQL for automated data ingestion, transformation, and reporting.",
          "Developed interactive Power BI dashboards to track KPIs for sales, logistics, and financial operations in real time.",
          "Created predictive models to forecast revenue trends, customer churn, and fraud risks, improving decision-making accuracy by 30%.",
          "Worked closely with stakeholders to translate business needs into measurable metrics and actionable insights."
        ]
      },
      {
        name: "Microservices Architecture & Cloud Infrastructure",
        details: [
          "Architected backend microservices in Spring Boot, improving system throughput by 3x.",
          "Deployed scalable infrastructure on Google Cloud Platform (GCP) using Docker, Kubernetes, and CI/CD pipelines.",
          "Optimized hybrid MySQL and MongoDB databases with advanced indexing strategies for faster query performance."
        ]
      }
    ],
    skills: {
      technical: [
        "Java",
        "Spring Boot",
        "Microservices",
        "MySQL",
        "MongoDB",
        "Python",
        "Power BI",
        "Data Engineering",
        "ETL",
        "SQL",
        "GCP",
        "Docker",
        "CI/CD",
        "Business Intelligence",
        "Predictive Analytics",
        "Fraud Detection",
        "Data Visualization"
      ],
      soft: [
        "Strategic Planning",
        "Data-Driven Decision Making",
        "Business Requirement Analysis",
        "Cross-functional Collaboration",
        "Problem-Solving"
      ]
    },
    achievements: [
      "Implemented automated ETL workflows reducing manual reporting time by 40%.",
      "Improved forecasting accuracy by 30% through predictive modeling.",
      "Reduced payment settlement time by 25% via optimized API integration.",
      "Delivered real-time business intelligence dashboards that enhanced executive decision-making."
    ]
  },
  {
    id: 2,
    img: "/colombomail.png",
    role: "Associate Software and Database Engineer",
    company: "Super Save Lanka (PVT) Ltd",
    emptype: "Dubai, United Arab Emirates · Full-time",
    duration: "February 2021 – August 2022",
    desc: [
      "As an Associate Software and Database Engineer, I focused on developing robust tracking systems, optimizing database performance, and implementing scalable web applications. My responsibilities included leading database schema design, maintaining system reliability, and driving operational efficiency through automation and real-time solutions.",
    ],
    keyProjects: [
      {
        name: "Advanced Parcel Tracking System",
        details: [
          "Designed and implemented a comprehensive Parcel Tracking System achieving 95% user satisfaction.",
          "Integrated real-time updates, OTP-based verification, and customer chat interface for enhanced user experience.",
          "Collaborated with third-party logistics APIs for seamless tracking coordination and updates.",
        ],
      },
      {
        name: "Database Architecture & Optimization",
        details: [
          "Engineered and optimized MySQL databases with advanced indexing, normalization, and stored procedures.",
          "Led database schema design implementing robust data models for scalability and maintainability.",
          "Implemented data consistency strategies to support high-performance transactions across multiple services.",
        ],
      },
      {
        name: "Workflow Management System",
        details: [
          "Developed a comprehensive Workflow Management System improving operational efficiency by 40%.",
          "Implemented task automation, real-time notifications, and interactive dashboards.",
          "Created seamless integration between frontend and backend APIs with OAuth2 and JWT authentication.",
        ],
      },
    ],
    skills: {
      technical: [
        "Java",
        "Spring Framework",
        "MySQL",
        "Microsoft Power BI",
        "Microservices Architecture",
        "Database Management",
        "OAuth2",
        "JWT",
        "API Integration",
        "Google Cloud Platform",
        "Agile Methodologies",
        "Scrum",
        "Jira"
      ],
      soft: ["Team Leadership", "Database Design", "System Architecture", "Performance Optimization"],
    },
    achievements: [
      "Achieved 95% user satisfaction with the Parcel Tracking System implementation.",
      "Improved operational efficiency by 40% through workflow automation and real-time systems.",
      "Maintained 99.9% system reliability and 24/7 uptime for Dubai branch operations.",
      "Successfully led database schema design ensuring scalability across multiple services.",
    ],
  },
  {
    id: 3,
    img: "/colombomail.png",
    role: "Application Administrator and Application Support Engineer",
    company: "Super Save Lanka (PVT) Ltd",
    emptype: "Colombo, Western Province, Sri Lanka · On-site · Full-time",
    duration: "February 2020 – January 2021",
    desc: [
      "As an Application Administrator and Application Support Engineer, I managed comprehensive website and eCommerce operations while developing critical financial systems. My role encompassed end-to-end system administration, database management, and the development of automated solutions that significantly improved operational efficiency and data accuracy.",
    ],
    keyProjects: [
      {
        name: "eCommerce Operations Management",
        details: [
          "Managed end-to-end website and eCommerce operations across Amazon, eBay, and Colombo Mall platforms.",
          "Ensured 99.9% uptime with streamlined order workflows and enhanced customer experience.",
          "Implemented comprehensive monitoring and maintenance protocols for optimal platform performance.",
        ],
      },
      {
        name: "Bill Payment and Data Management System",
        details: [
          "Designed and developed a comprehensive automated bill payment and data management system.",
          "Integrated with third-party payment gateways ensuring secure and reliable financial transactions.",
          "Automated financial processes by 80% while improving transaction accuracy by 95%.",
        ],
      },
      {
        name: "Database Administration & System Support",
        details: [
          "Administered internal databases with secure backup and recovery protocols.",
          "Performed data quality checks and optimized database performance for consistent data integrity.",
          "Provided cross-functional hardware maintenance, system troubleshooting, and analytical reporting.",
        ],
      },
    ],
    skills: {
      technical: [
        "Website Administration",
        "eCommerce Operations", 
        "Financial Systems",
        "API Development",
        "Database Management",
        "Hardware Support",
        "Reporting & Analysis",
        "Payment Gateway Integration",
        "System Monitoring"
      ],
      soft: ["Cross-functional Collaboration", "System Administration", "Financial Analysis", "Problem-Solving"],
    },
    achievements: [
      "Maintained 99.9% uptime across multiple eCommerce platforms (Amazon, eBay, Colombo Mall).",
      "Automated financial processes by 80% while achieving 95% improvement in transaction accuracy.",
      "Implemented secure backup and recovery protocols ensuring consistent data integrity.",
      "Generated analytical reports that guided strategic business decisions and operational improvements.",
    ],
  },
  {
    id: 4,
    img: "/Naascampus.jpeg",
    role: "Website Developer",
    company: "Naas Campus",
    emptype: "Colombo · Contract",
    duration: "Contract Project",
    desc: [
      "As a Website Developer for Naas Campus, I designed and developed a dynamic campus website that significantly enhanced user engagement and streamlined administrative processes. The project focused on creating an interactive platform with real-time capabilities and secure payment integration.",
    ],
    keyProjects: [
      {
        name: "Naas Campus Dynamic Website",
        details: [
          "Designed and developed a dynamic campus website using Vue.js, Firebase, and FireCMS.",
          "Implemented a secure and efficient online payment system for student transactions.",
          "Created a dynamic student registration process reducing administrative overhead by 35%.",
          "Integrated real-time notifications to keep students updated on campus events and announcements.",
        ],
      },
    ],
    skills: {
      technical: [
        "Vue.js",
        "FireCMS",
        "Firebase",
        "MySQL",
        "API Development",
        "Payment Integration",
        "Real-time Systems",
        "Agile Web Development"
      ],
      soft: ["Client Communication", "Project Management", "User Experience Design", "Time Management"],
    },
    achievements: [
      "Increased website engagement by 40% through real-time notifications and interactive features.",
      "Reduced administrative overhead by 35% with streamlined registration and payment processes.",
      "Successfully delivered a comprehensive solution that exceeded client expectations for functionality and user experience.",
    ],
  },
  {
    id: 5,
    img: "/codechainwithdescription.png",
    role: "Founder & Chief Executive Officer",
    company: "CodeChain Labs",
    emptype: "Colombo, Western Province, Sri Lanka · Freelance",
    duration: "Ongoing",
    desc: [
      "As Founder & CEO of CodeChain Labs, I lead a technology consultancy focused on delivering innovative software solutions, AI integration, and digital transformation services. My role encompasses business leadership, technical innovation, research and development, and mentoring the next generation of developers.",
    ],
    keyProjects: [
      {
        name: "Client-Facing Applications & Digital Solutions",
        details: [
          "Developed comprehensive websites and applications with integrated CMS and SEO optimization.",
          "Implemented secure online payment systems and e-commerce functionality for diverse client needs.",
          "Created scalable solutions that improved clients' digital presence and operational efficiency by 30%.",
        ],
      },
      {
        name: "AI Integration & Innovation Projects",
        details: [
          "Integrated cutting-edge AI solutions into client applications for enhanced user interactions.",
          "Developed automated decision-making processes and intelligent recommendation systems.",
          "Researched and implemented emerging technologies to provide competitive advantages for clients.",
        ],
      },
      {
        name: "R&D, Content Creation & Mentorship",
        details: [
          "Conducted extensive research on emerging IT technologies and their practical applications.",
          "Produced technical content, tutorials, and industry insights for knowledge sharing.",
          "Mentored students in developing final-year projects, turning concepts into practical applications.",
        ],
      },
    ],
    skills: {
      technical: [
        "Java",
        "Spring Boot",
        "React.js",
        "Vue.js",
        "Node.js",
        "MySQL",
        "MongoDB",
        "Firebase",
        "AI Integration",
        "API Development",
        "R&D",
        "Content Writing",
        "SEO",
        "E-commerce Development"
      ],
      soft: ["Entrepreneurship", "Business Leadership", "Client Relationship Management", "Strategic Planning", "Mentorship"],
    },
    achievements: [
      "Successfully launched and managed multiple high-impact client projects with 100% satisfaction rate.",
      "Increased clients' operational efficiency by 30% through innovative software solutions.",
      "Built a strong reputation as a reliable technology partner delivering cutting-edge solutions on time.",
      "Mentored over 20 students in successful final-year project development and career guidance.",
      "Established CodeChain Labs as a recognized name in Sri Lankan technology consultancy space.",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "/london-met-uni.jpg",
    school: "UK London Metropolitan University",
    date: "Feb 2023 - Feb 2024",
    grade: "3.2 GPA",
    // desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Kalinga Institute of Industrial Technology, Bhubaneswar. I have completed 4 semesters and have a CGPA of 8.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "BEng (Hons) in Software Engineering",
  },
  {
    id: 1,
    img: "/pearson-logo.webp",
    school: "Pearson College London",
    date: "Aug 2021 - Dec 2022",
    grade: "Merit",
    // desc: "I completed my class 12 high school education at Methodist School, Dankuni, where I studied Science with Computer Science.",
    degree: "Higher National Diploma, Computer Software Engineering",
  },
];

export const projects = [
  {
    id: 1,
    title: "Automated ETL & Data Pipeline System",
    description:
      "Developed an automated ETL pipeline to extract data from multiple sources, transform it into a standardized format, and load it into MySQL and PostgreSQL databases. This system integrated sales, logistics, and customer data, enabling real-time reporting in Power BI. Implemented Python scripts with Pandas and NumPy for data cleaning, transformation, and scheduling. Deployed workflows on AWS Lambda for scalability and cost efficiency.",
    image: "/dataanalystimg01.png", // ETL pipeline icon
    tags: [
      "Python",
      "Pandas",
      "NumPy",
      "MySQL",
      "PostgreSQL",
      "AWS Lambda",
      "ETL"
    ],
    category: ["data engineering", "data analytics"],
    github: "https://github.com/HussainMBH/etl-data-pipeline",
    webapp: "https://github.com/HussainMBH/etl-data-pipeline",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/"
      }
    ]
  },
  {
    id: 2,
    title: "Logistics & Parcel Management Data Dashboard",
    description:
      "Built an interactive Power BI dashboard for the company’s logistics and parcel tracking operations. Data was sourced from MySQL databases and transformed using Power Query. The dashboard provided real-time KPIs such as delivery times, pending parcels, and route efficiency. Optimized SQL queries to handle large datasets and reduce refresh times by 40%. Enabled data-driven decision-making for operations and route planning.",
    image: "/logisticsdataanalyst.png", // dashboard icon
    tags: [
      "Power BI",
      "SQL",
      "MySQL",
      "Data Visualization",
      "DAX",
      "Power Query"
    ],
    category: ["data analytics", "business analytics", "data engineering"],
    github: "https://github.com/HussainMBH/logistics-parcel-dashboard",
    webapp: "https://github.com/HussainMBH/logistics-parcel-dashboard",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/"
      }
    ]
  },
  {
    id: 3,
    title: "E-Commerce Sales & Customer Insights Platform",
    description:
      "Designed and implemented a data analytics solution to monitor e-commerce sales trends, customer purchasing behavior, and inventory turnover. Created SQL-based data models and connected them to Tableau dashboards for visual analytics. Automated daily sales reports and integrated Google BigQuery for large-scale analysis. Provided actionable insights that improved product stocking efficiency by 25%.",
    image: "/ecommercedataanalyst.png", // analytics & e-commerce icon
    tags: [
      "Tableau",
      "SQL",
      "Google BigQuery",
      "Data Modeling",
      "Business Analytics"
    ],
    category: ["business analytics", "e-commerce", "data engineering", "data analytics"],
    github: "https://github.com/HussainMBH/ecommerce-insights",
    webapp: "https://github.com/HussainMBH/ecommerce-insights",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/"
      }
    ]
  },
  {
    id: 2,
    title: "Gemini AI Integration System",
    description:
      "The Chat and Image Upload project is a Spring Boot application integrated with Vertex AI and Gemini AI, allowing users to engage in AI-driven chat interactions and perform image uploads for analysis. The application processes images and text through AI models, offering real-time feedback and insights based on the uploaded content. It utilizes advanced API functions and object-oriented programming (OOP) principles to ensure seamless integration and efficient data handling.",
    image: "geminiaispringbootproject.png",
    tags: [
      "Spring Boot",
      "Vertex AI",
      "Postman API Testing",
      "Eslint",
      "React Js",
      "MongoDb",
      "Redux",
    ],
    category: ["web app", "ai app", "springboot application", "data engineering"],
    github:
      "https://github.com/HussainMBH/Chat-and-Image-Upload-and-check-Spring-Boot-Vertex-AI-with-Gemini-AI-Integration-API-Function",
    webapp:
      "https://github.com/HussainMBH/Chat-and-Image-Upload-and-check-Spring-Boot-Vertex-AI-with-Gemini-AI-Integration-API-Function",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 3,
    title: "AI Chat System",
    description:
      "Chat and Image Upload and check Spring Boot Vertex AI with Gemini AI Integration API Function",
    image: "mbhai.png",
    tags: [
      "Spring Boot",
      "Vertex AI",
      "Postman API Testing",
      "Eslint",
      "React Js",
      "MongoDb",
      "Redux",
    ],
    category: ["web app", "ai app", "data engineering"],
    github:
      "https://github.com/HussainMBH/Chatting-and-Image-Analyzing-with-Gemini-AI-Integrating-developed-by-ReactJS-and-Redux",
    webapp: "https://mbhaichat.netlify.app/",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 4,
    title: "WORKFLOW System",
    description:
      "There have parcel sending and tracking system end to end for customer’s trust. In this project, I add a crud function for branches, employees and parcels. Each parcel has a unique tracking number, I added this function using a few algorithms. Have a check tracking number system, a report view and a print function system. It has two login users, one for admin and a second for company employees.",
    image: "workflow.jpg",
    tags: ["PHP", "MySQL", "Postman API Testing", "JavaScript"],
    category: ["web app", "springboot application", "data engineering"],
    github: "https://github.com/HussainMBH/work-flow-system-final-project",
    webapp: "www.linkedin.com/in/mohamedbahirhussain",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 5,
    title: "Chat App",
    description:
      "A comprehensive travel booking platform that allows users to book flights, hotels, and rental cars, and offers curated recommendations for popular destinations.",
    image: "chatapp.jpg",
    tags: ["Spring Boot", "WebSocket", "React Js", "MongoDb"],
    category: ["web app", "springboot application"],
    github:
      "https://github.com/HussainMBH/Chat-and-Image-Upload-and-check-Spring-Boot-Vertex-AI-with-Gemini-AI-Integration-API-Function",
    webapp: "www.linkedin.com/in/mohamedbahirhussain",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 6,
    title: "Naas Campus Management System",
    description:
      "I am thrilled to announce the successful development of a dynamic campus website for one of our esteemed clients. This project has been a collaborative effort, utilizing cutting-edge technologies including Vue.js, Sanity CMS, and cloud storage solutions to create a seamless user experience.",
    image: "cms.png",
    tags: ["VueJS", "Firebase", "FireCMS", "MySQl", "NodeJS"],
    category: "web app",
    github:
      "https://github.com/HussainMBH/Campus_Management_Website_Using_VueJs_and_Firebase",
    webapp: "https://naascampus.com",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 7,
    title: "Voice to Text",
    description:
      "Developed a Voice-to-Text application using React JS, featuring seamless voice recognition and transcription capabilities. Integrated a Copy to Clipboard functionality for easy transfer of text outputs. Enhanced user experience with intuitive UI and robust performance.",
    image: "voicetotext.jpg",
    tags: [
      "Postman API Testing",
      "Eslint",
      "React Js",
      "Copy Clipboard functionality",
    ],
    category: "web app",
    github:
      "https://github.com/HussainMBH/Speech_Recognition_App_in_ReactJS_with_Copy_to_Clipboard_Functionality",
    webapp: "https://mbhvoicetotext.netlify.app",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 8,
    title: "Hot Desk Booking App",
    description:
      "Developed a Hot Desk Booking System using NextJS, ReactJS, TypeScript, and MySQL. The system allows users to easily reserve desks, manage bookings, and view available spaces in real-time. Designed with a user-friendly interface and robust backend to ensure seamless and efficient desk management.",
    image: "deskbooking.png",
    tags: ["ReactJS", "NextJS", "TypeScript", "MySQL"],
    category: "web app",
    github:
      "https://github.com/HussainMBH/Office_desk_Reservation_System_using_Typescript",
    webapp:
      "https://www.linkedin.com/posts/mohamedbahirhussain_im-happy-to-share-this-office-desk-booking-activity-7201580766730883073-ol6h?utm_source=share&utm_medium=member_desktop",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 9,
    title: "Fuel Filling Project",
    description: [
      "The Fuel Filling Station System project, developed in Java, leverages Object-Oriented Programming (OOP) principles to create a robust and scalable application for managing fuel station operations. It encapsulates key functionalities such as tracking fuel levels, processing transactions, and generating reports, ensuring a modular and maintainable code structure. By utilizing classes and objects, the system efficiently handles various components like fuel pumps, payment methods, and customer data, enhancing both functionality and user experience.",
    ],
    image: "fuelfillingproject.png",
    tags: ["Java", "OOP Concept"],
    category: "core application",
    github:
      "https://github.com/HussainMBH/Fuel_Filling_Station_System_Project_developed_by_Java",
    webapp:
      "https://github.com/HussainMBH/Fuel_Filling_Station_System_Project_developed_by_Java",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 10,
    title: "Car Rental Project",
    description: [
      "The Car Rental Project is a Java-based application designed using object-oriented programming (OOP) principles. It streamlines the process of renting vehicles, offering features like booking management, vehicle inventory, and customer profiles. The project emphasizes modular design, encapsulation, inheritance, and polymorphism to ensure a robust and scalable system.",
    ],
    image: "carrentalproject.png",
    tags: [
      "Java",
      "OOP Concept",
      "Car Rental",
      "Booking Management",
      "Vehicle Inventory",
    ],
    category: "core application",
    github:
      "https://github.com/HussainMBH/Car_Rental_System_Developed_by_Java_OOP_Concepts",
    webapp:
      "https://github.com/HussainMBH/Car_Rental_System_Developed_by_Java_OOP_Concepts",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 11,
    title: "ATM Bank Project",
    description: [
      "The ATM Bank Project is a Java application built using object-oriented programming (OOP) principles to simulate ATM transactions and banking operations. It provides functionalities such as account management, balance inquiries, fund transfers, and transaction history, all while ensuring secure and reliable interactions. The project utilizes OOP concepts like encapsulation, inheritance, and polymorphism to create a modular, maintainable, and extensible system.",
    ],
    image: "atmproject.jpg",
    tags: [
      "Java",
      "OOP Concept",
      "ATM Simulation",
      "Cash Management",
      "Bank Transactions",
      "Account Management",
    ],
    category: "core application",
    github: "https://github.com/HussainMBH/atm_bank_system",
    webapp: "https://github.com/HussainMBH/atm_bank_system",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 12,
    title: "Cash Recycler Project",
    description: [
      "The Cash Recycler project is a Java-based application developed using object-oriented programming (OOP) concepts. It automates the process of accepting, counting, and dispensing cash, ensuring accurate and efficient cash management for banks or retail environments. The project leverages OOP principles like encapsulation, inheritance, and polymorphism to create a modular and scalable system that handles various denominations and transaction types.",
    ],
    image: "cashrecyclerproject.png",
    tags: [
      "Java",
      "OOP Concept",
      "Cash Recycler",
      "Cash Management",
      "Transaction Automation",
    ],
    category: ["core application"],
    github:
      "https://github.com/HussainMBH/Cash_Recycler_Machine_project_developed_by_Java",
    webapp:
      "https://github.com/HussainMBH/Cash_Recycler_Machine_project_developed_by_Java",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 13,
    title: "Banking Application Project",
    description: [
      "The Banking Application is a Java-based project developed with Spring Boot, Spring Data JPA, Hibernate, and MySQL, utilizing object-oriented programming (OOP) principles. It provides comprehensive banking functionalities, including account management, transaction processing, and customer services, ensuring a secure and efficient banking experience. The application leverages OOP concepts such as encapsulation, inheritance, and polymorphism to create a scalable and maintainable system with robust data handling and business logic.",
    ],
    image: "banksystemproject.png",
    tags: [
      "Java",
      "OOP Concept",
      "Spring Boot",
      "Spring Data JPA",
      "Hibernate",
      "MySQL",
      "Banking Application",
    ],
    category: ["springboot application", "web app"],
    github:
      "https://github.com/HussainMBH/Banking_Application_developed_by_Java_SpringBoot_SpringData_JPA_Hibernate_MySQL",
    webapp:
      "https://github.com/HussainMBH/Banking_Application_developed_by_Java_SpringBoot_SpringData_JPA_Hibernate_MySQL",
    developer: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
];

export const blogs = [
  {
    id: 14,
    title:
      "Navigating the Full Stack Development Internship Interview: A Personal Experience.",
    description: [
      "Embarking on the journey of securing an internship in full-stack development can be both exhilarating and nerve-wracking. Recently, I had the opportunity to sit through one such interview, and the experience was enlightening, to say the least. In this article, I’ll share my firsthand encounter, shedding light on the types of questions asked and how I navigated through them. As a student specializing in full-stack development with a focus on React JS and Java, I was eager yet uncertain about what lay ahead in the interview room. The realm of full-stack development is vast, and the questions posed could range from basic concepts to intricate problem-solving scenarios. I’ll share everything step by step, first I’m sharing about the OOP Concept and its short explanation.",
    ],
    image: "prepartioninterview.png",
    tags: ["SOftware Engineer", "Internship", "OOP Concept", "Full Stack"],
    bloglink:
      "https://medium.com/@mohamedbahirhussain/navigating-the-full-stack-development-internship-interview-a-personal-experience-f6c0c633b034",
    bloger: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 15,
    title:
      "Simplifying Real-Time Website Development with Vue.js, Firebase, and FireCMS",
    description: [
      "In today’s fast-paced digital landscape, the demand for dynamic and real-time websites is ever-growing. Developers are constantly seeking efficient solutions to streamline the development process without compromising on functionality and performance. Enter Vue.js, Firebase, and FireCMS — a powerful trio that empowers developers to create responsive and real-time websites with ease. In this article, I’ll explore how combining Vue.js, a progressive JavaScript framework, with Firebase, Google’s mobile and web application development platform, and FireCMS, an open-source headless CMS specifically designed for Firebase, can significantly simplify the process of building real-time websites.",
    ],
    image: "vuefirebase.png",
    tags: ["VueJS", "Firebase", "FireCMS", "Website Development"],
    bloglink:
      "https://mohamedbahirhussain.medium.com/simplifying-real-time-website-development-with-vue-js-firebase-and-firecms-3a4f451404ca",
    bloger: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 16,
    title: "Understanding R&D in Software Product Development",
    description: [
      "In software, research and development (R&D) combines the study of innovative technologies, techniques, and market trends with the creation of prototypes, tools, or features derived from this research.",
    ],
    image: "r&d.png",
    tags: [
      "Research & Development",
      "Software Product Development",
      "Software Engineer",
      "Website Development",
    ],
    bloglink:
      "https://mohamedbahirhussain.medium.com/understanding-r-d-in-software-product-development-112dfa56575a",
    bloger: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 17,
    title: "Springboot Hibernate Framework",
    description: [
      "In software, research and development (R&D) combines the study of innovative technologies, techniques, and market trends with the creation of prototypes, tools, or features derived from this research.",
    ],
    image: "springhibernate.jpg",
    tags: ["Spring Boot", "Hibernate", "JPA", "Software Development"],
    bloglink:
      "https://mohamedbahirhussain.medium.com/springboot-hibernate-framework-3f8bdf14e9bf",
    bloger: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
  {
    id: 18,
    title: "Spring Boot — Project Structure Practices",
    description: [
      "In this article, I am going to talk about package structures for Spring Boot applications and give the one I create whenever I started a new project. Proper packaging in a project is important because when the project grows or someone else is assigned to your project, it must be easy to get around different kind of files. For example, when you need a file of type model, you just directly go into the model package and easily find what you are looking for. If you do no have such a structure, it becomes a time-consuming problem in large projects.",
    ],
    image: "projectstructure.png",
    tags: [
      "Spring Boot",
      "REST Controller",
      "MongoDB",
      "Repository",
      "NoSQL Database",
    ],
    bloglink:
      "https://mohamedbahirhussain.medium.com/springboot-hibernate-framework-3f8bdf14e9bf",
    bloger: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
];

export const vlogs = [
  {
    id: 19,
    title: "Naas Campus Management System",
    description: [
      "I am thrilled to announce the successful development of a dynamic campus website for one of our esteemed clients. This project has been a collaborative effort, utilizing cutting-edge technologies including Vue.js, Sanity CMS, and cloud storage solutions to create a seamless user experience.",
    ],
    image: "https://img.youtube.com/vi/_Js7xi9_Qkc/hqdefault.jpg",
    vloglink: "https://www.youtube.com/watch?v=_Js7xi9_Qkc",
    date: "2024-09-07",
    tags: ["VueJS", "Firebase", "FireCMS", "MySQl", "NodeJS"],
    vloger: [
      {
        name: "Mohamed Bahir Hussain",
        img: "mohamedbahirhussain.jpeg",
        github: "https://github.com/HussainMBH",
        linkedin: "https://www.linkedin.com/in/mohamedbahirhussain/",
      },
    ],
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];